module.exports = __webpack_public_path__ + "startpage-be63061f/template-6-4eeaf05a49d9b21d0e0f97b664b3198e.jpg";